import React, { useState } from 'react';
import { Table, Button, Checkbox, Progress, Space, Card } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { Color } from 'antd/es/color-picker';

const ImeiFinderReportTable = ({ data = [], imei, isToView }) => {
  // Your exact columns from the original code

  const viewReport = () => {
    window.open(`/live-report/${imei}`, '_blank');
  }
  const viewReport2 = (record) => {
    window.open(`https://report.gearvu.io/report/?tier=BASIC&session=${record?.sessionId}`, '_blank');
  }


  const columns = [
    {
      title: '📧',
      dataIndex: 'email',
      key: 'email',
      width: 60,
      align: 'center',
      render: () => <MailOutlined style={{ color: '#1890ff' }} />
    },
    { title: 'Brand', dataIndex: 'brand', key: 'brand', width: 80 },
    { title: 'Model', dataIndex: 'model', key: 'model', width: 100 },
    { title: 'IMEI', dataIndex: 'imei', key: 'imei', width: 120 },
    { title: 'Storage', dataIndex: 'capacity', key: 'capacity', width: 80 },
    { title: 'Carrier', dataIndex: 'carrier', key: 'carrier', width: 80 },
    { title: 'Grade', dataIndex: 'grade', key: 'grade', width: 70 },
    { title: 'Functional Status', dataIndex: 'functional', key: 'functional', width: 120 },
    {
      title: 'Offer Price',
      dataIndex: 'price',
      key: 'price',
      width: 100,
      render: p => p ? `$${p}` : '-'
    },
    {
      title: 'New Price',
      dataIndex: 'newPrice',
      key: 'newPrice',
      width: 100,
      render: p => p ? `$${p}` : '-'
    },
    {
      title: 'Good Price',
      dataIndex: 'goodPrice',
      key: 'goodPrice',
      width: 100,
      render: p => p ? `$${p}` : '-'
    },
    {
      title: 'Bad Price',
      dataIndex: 'badPrice',
      key: 'badPrice',
      width: 100,
      render: p => p ? `$${p}` : '-'
    },
    {
      title: 'Recycle Value',
      dataIndex: 'recyclePrice',
      key: 'recyclePrice',
      width: 120,
      render: p => p ? `$${p}` : '-'
    },
    { title: 'Blacklist Status', dataIndex: 'blacklistStatus', key: 'blacklistStatus', width: 120 },
    { title: 'Response Status', dataIndex: 'responseStatus', key: 'responseStatus', width: 120 },
    { title: 'Greylist Status', dataIndex: 'greylistStatus', key: 'greylistStatus', width: 120 },
    {
      title: 'Action',
      key: 'action',
      width: 70,
      fixed: 'right',
      render: (_, record) => (
        <Space size="small">
          {isToView && (
            <>
            <Button
              type="primary"
              size="small"
              onClick={() => viewReport(record)}
              style={{
                backgroundColor: 'rgb(206, 46, 40)',
                borderColor: 'rgb(206, 46, 40)',
                fontSize: '11px',
                height: '24px',
                padding: '0 8px'
              }}
              >
              View
            </Button>
               <Button
              type="primary"
              size="small"
              onClick={() => viewReport2(record)}
              style={{
                backgroundColor: 'rgb(206, 46, 40)',
                borderColor: 'rgb(206, 46, 40)',
                fontSize: '11px',
                height: '24px',
                padding: '0 8px'
              }}
            >
              2.0
            </Button>
              </>
          )}
        </Space>
      )
    },
   
  ];

  // Sample data matching your columns


  const tableData = data.length > 0 ? data : [];

  return (
    <div style={{ padding: '20px', backgroundColor: '#f5f5f5' }}>
      <Card
        style={{
          borderRadius: '8px',
          overflow: 'hidden',
          border: '2px solid #ccc'
        }}
        bodyStyle={{ padding: 0 }}
      >
        {/* Header */}
        <div style={{
          backgroundColor: 'rgb(206, 46, 40)',
          color: 'white',
          padding: '12px 20px',
          fontSize: '16px',
          fontWeight: 'bold',
          textAlign: 'center'
        }}>
          Search Results
        </div>

        {/* Status Bar */}
        <div style={{
          backgroundColor: '#e8e8e8',
          padding: '12px 20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #ddd'
        }}>
          <span style={{ fontWeight: 'bold' }}>
            Operator Name: <span style={{ fontWeight: 'normal' }}>ALL</span>
          </span>
          <Space size="large">
            <span style={{ fontWeight: 'bold' }}>Status:</span>
            <Checkbox
              // checked={data.every(item => item.status === 'Success')}
              // defaultChecked
              style={{
                '& .ant-checkbox-checked .ant-checkbox-inner': {
                  backgroundColor: 'black',
                  borderColor: 'black'
                }
              }}
            >
              <span >Passed</span>
            </Checkbox>
            <Checkbox
              // checked={data.every(item => item.status === 'Success')}
              // defaultChecked
              style={{
                '& .ant-checkbox-checked .ant-checkbox-inner': {
                  backgroundColor: 'black',
                  borderColor: 'black'
                }
              }}
            >
              <span >Failed</span>
            </Checkbox>
            <Checkbox
              // checked
              // defaultChecked
              style={{
                '& .ant-checkbox-checked .ant-checkbox-inner': {
                  backgroundColor: 'black',
                  borderColor: 'black'
                }
              }}
            >
              <span >Not Completed</span>
            </Checkbox>
          </Space>
        </div>

        {/* Table */}
        <Table
          dataSource={tableData}
          columns={columns}
          pagination={{
            pageSize: 10,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            style: { padding: '16px 20px' }
          }}
          scroll={{ x: 'max-content' }}
          size="small"
          style={{
            '& .ant-table-thead > tr > th': {
              backgroundColor: 'rgb(206, 46, 40)',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '12px',
              padding: '8px 12px'
            },
            '& .ant-table-tbody > tr > td': {
              fontSize: '11px',
              padding: '8px 12px'
            }
          }}
        />



        {/* Export Buttons */}
        {/* <div style={{
          backgroundColor: '#666',
          padding: '12px 20px',
          display: 'flex',
          gap: '10px',
          flexWrap: 'wrap'
        }}>
          <Button 
            size="small" 
            style={{ 
              backgroundColor: '#555', 
              borderColor: '#777', 
              color: 'white' 
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#777'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#555'}
          >
            Export Shown
          </Button>
          <Button 
            size="small" 
            style={{ 
              backgroundColor: '#555', 
              borderColor: '#777', 
              color: 'white' 
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#777'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#555'}
          >
            Export Shown To PDF
          </Button>
          <Button 
            size="small" 
            style={{ 
              backgroundColor: '#555', 
              borderColor: '#777', 
              color: 'white' 
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#777'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#555'}
          >
            Export Shown With Manual
          </Button>
          <Button 
            size="small" 
            style={{ 
              backgroundColor: '#555', 
              borderColor: '#777', 
              color: 'white' 
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#777'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#555'}
          >
            Export Shown With Image Links
          </Button>
        </div> */}
      </Card>

      <style jsx>{`
        .ant-table-thead > tr > th {
          background-color: rgb(206, 46, 40) !important;
          color: white !important;
          font-weight: bold !important;
          font-size: 12px !important;
          padding: 8px 12px !important;
          border-bottom: 1px solid rgb(206, 46, 40) !important;
        }
        .ant-table-tbody > tr > td {
          font-size: 14px !important;
          padding: 8px 12px !important;
        }
        .ant-table-tbody > tr:nth-child(even) {
          background-color: #fafafa !important;
        }
        .ant-checkbox-checked .ant-checkbox-inner {
          background-color: green !important;
          border-color: green !important;
        }
        .ant-checkbox:hover .ant-checkbox-inner,
        .ant-checkbox-input:focus + .ant-checkbox-inner {
          border-color: green !important;
        }
      `}</style>
    </div>
  );
};

export default ImeiFinderReportTable;